import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { DetailsFaq } from '@components/details-faq/models';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { FaqStore } from '@stores';

@Component({
  selector: 'app-details-faq',
  templateUrl: './details-faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, TranslatePipe, ImageComponent, RouterLink, HandleHtmlLinksDirective],
})
export class DetailsFaqComponent extends AbstractDynamicComponent<DetailsFaq> implements OnInit {
  private readonly faqStore = inject(FaqStore);

  ngOnInit(): void {
    this.faqStore.update('currentCategory', this.data.category);
  }
}
